import React from "react";
import { useState } from "react";
import { AdverseEvents } from "../../../components/MedicalRecords/AdverseEvents";
import { useAdverseEvents, useAdverseEventHistoryByConcept } from "../Hooks/useAdverseEvents";
import { AuditModal } from "../../../components/AuditTrail/AuditModal";
import { AuditTrail } from "../../Admin/AuditTrail";
import { useTranslation } from "react-i18next";
import { ExpandableContent } from "../../../components/CustomControls/ExpandableContent";
import { ModalConceptHistory } from "../Modals/ModalConceptHistory";

export const AdverseEventsListContainer = ({ mrn, medicalRecordNumber, entryId, expandedAll }) => {
    const { t } = useTranslation();
    const [adverseEvents, query, totalSize, isLoading, handleTableChange, , setSearchTerm] = useAdverseEvents(medicalRecordNumber, entryId, false);

    const [modal, setModal] = useState(null);
    const handleAuditTrail = (entityId) => {
        setModal(
            <AuditModal
                onClose={() => { setModal(null); }}
                title={t("auditTrail.audit")}
            >
                <AuditTrail entity="AdverseEvents" entityId={entityId} medicalRecordNumber={medicalRecordNumber} />
            </AuditModal>
        )
    }

    const handleHistoryByConcept = (conceptId, _mrn) => {
        setModal(<ModalConceptHistory
            onClose={() => { setModal(null); }}
            title={t("medicalRecords.history.byConcept")}
            medicalRecordNumber={medicalRecordNumber || mrn}
            conceptId={conceptId}
            useHistoryHook={useAdverseEventHistoryByConcept}
            getConceptName={(row) => row.adverseEffect}
            getCycleSubtitle={(row) => row.intensity || ''}
        />)
    }

    if (entryId && totalSize === 0)
        return null;

    return (
        <ExpandableContent title={t("medicalRecords.adverseEvents.title")} content="adverseEvents" expandedAll={expandedAll}>
            {modal}
            <AdverseEvents
                withCard={false}
                data={adverseEvents}
                query={query}
                entryId={entryId}
                totalSize={totalSize}
                isLoading={isLoading}
                onTableChange={handleTableChange}
                onAuditTrail={handleAuditTrail}
                onHistoryByConcept={handleHistoryByConcept}
                onSearchTermChange={setSearchTerm}
            />
        </ExpandableContent>
    );
}